<script setup>
import { computed, ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import AttributeModal from "./AttributeModal.vue"
import AttributeEditModal from "./AttributeEditModal.vue"
import AttributesTable from "./AttributesTable.vue"

const title = "مدیریت ویژگی های محصولات"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت ویژگی های محصولات",
    active: true,
  },
])

const DEFAULT_ATTRIBUTE = {
  id: "",
  category_id: "",
  attribute_name: "",
  attribute_displayname: "",
}

const allCategories = computed(() => store.state.allCategories)

const attributeModel = ref({ ...DEFAULT_ATTRIBUTE })
const showAttributeModal = ref(false)
const showAttributeEditModal = ref(false)

const showAddNewModal = () => {
  showAttributeModal.value = true
}

const showEditModal = () => {
  showAttributeEditModal.value = true
}

function editAttribute(att) {
  store.dispatch("getAttribute", att.id).then(({ data }) => {
    attributeModel.value = data.data
    showEditModal()
  })
}

const onModalClose = () => {
  attributeModel.value = { ...DEFAULT_ATTRIBUTE }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="attributeList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست ویژگی های محصولات</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن ویژگی
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- attributes table  -->

          <AttributesTable @clickEdit="editAttribute" />

          <!-- add and edit attribute modal  -->

          <AttributeModal
            v-model="showAttributeModal"
            :attribute="attributeModel"
            :allCategories="allCategories"
            @close="onModalClose"
          />

          <AttributeEditModal
            v-model="showAttributeEditModal"
            :attribute="attributeModel"
            :allCategories="allCategories"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}

.v-select-rtl {
  direction: rtl;
  text-align: right;
}

.vs__search,
.vs__search:focus {
  line-height: 1.5;
  font-size: 0.8125rem;
  font-weight: 400;
  padding: 0.25rem 0.7rem 0.25rem 2.5rem !important;
}

.vs__clear {
  margin-left: 8px;
}

.vs__actions {
  padding: 4px 0px 0px 16px;
}

.vs__dropdown-menu {
  right: 0 !important;
  left: auto;
  text-align: right;
}
</style>
